import React from 'react';
import PublicLayout from "../Public";
import "../../resources/css/customAnt.css";
import 'antd/lib/form/style/css';
import 'antd/lib/row/style/css';
import 'antd/lib/col/style/css';
import 'antd/lib/input/style/css';
import 'antd/lib/input-number/style/css';
import 'antd/lib/select/style/css';
import {connect} from "react-redux";
import {Button, Col, Form, Input, Row} from "antd";
import language from "../../languages/language";
import validateID from "../../actions/validateID";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import _ from "lodash";
import checkProfile from "../../actions/checkProfile";

class ValidateID extends React.Component
{
    componentDidMount()
    {
        this.props.checkProfile({userName:this.props.userName});
    }

    render()
    {
        return <PublicLayout title={'logo'} size={'medium'}>
            <Form onFinish={this.props.validateID} className={'regularForm'}>
                <TitleAndInfo info={language[this.props.language].signUpText}/>
                <Row style={{marginBottom: 40}}/>
                <Row justify={'center'} style={{width:'100%'}}>
                    <Col span={12}>
                        <Form.Item name="cedula"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input placeholder={language[this.props.language].idLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{marginBottom: 40}}/>
                <Row justify={'center'} style={{width:'100%'}}>
                    <Col span={12}>
                        <Form.Item className={'text-center'}>
                            <Button style={{width:'100%'}} type="primary light-blue rounded" htmlType={'submit'}>
                                {language[this.props.language].nextLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{marginBottom: 40}}/>
            </Form>
        </PublicLayout>;

    }
}
function mapStateToProps(state) {
    let queryParams = state.router.location.search ? _.reduce(state.router.location.search.substring(1).split("&"),
        (result, value) => {
            let params = value.split("=");
            result[params[0]] = params[1];
            return result;
        }, {}) : {};
    return {
        language: state.auth.language,
        userName:queryParams.userName
    }
}
export default connect(mapStateToProps,{validateID,checkProfile})(ValidateID);